import { startOfDay, endOfDay, toDate, format } from 'date-fns';
import { TZDate, tz } from '@date-fns/tz';

const DATE_FORMAT = 'yyyy/MM/dd HH:mm:ssxxx';

const calcZonedDate = (date, timeZone, fn, options) => {
  const parsedDate = toDate(date);
  const nzDate = new TZDate(parsedDate, timeZone);
  return format(fn(nzDate, options), DATE_FORMAT, { in: tz(timeZone) });
};

export const getZonedEndOfDay = (date, timeZone) => calcZonedDate(date, timeZone, endOfDay);

export const getZonedStartOfDay = (date, timeZone) => calcZonedDate(date, timeZone, startOfDay);

/**
 * @param {number} time
 * @returns {string} - Format 'hh:mm:ss'
 */
export const secondToTimer = time => [
    parseInt(time / 3600, 10),
    parseInt(time / 60, 10),
    time % 60
  ].map(value => String(value).padStart(2, 0)).join(':');
